var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mo-pageheader flex flex-space"},[_c('div',{staticClass:"title"},[_vm._t("title")],2),_c('div',{staticClass:"action"},[_vm._t("action")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }